// extracted by mini-css-extract-plugin
export default {"accordionContainer":"accordionContainer__xsHwL","expand":"expand__WKZh5","body":"body__3VE6h","icon":"icon__Jogs1","noAbsoluteIcon":"noAbsoluteIcon__Q5IOO","header":"header__1IQn0"};